<script setup>
import AgentLayout from "@/views/layouts/AgentLayout.vue";
import ConversationsAnalytics from "@/components/ConversationsAnalytics.vue";
</script>

<template>
  <AgentLayout>
    <ConversationsAnalytics />
  </AgentLayout>
</template>
